"use client";
// Textos y fotos de los tours tal como se editaron en el panel (una sola consulta por visita). Mientras llegan, o sin servidor, se ve el catálogo.
import { useEffect, useState } from "react";
import type { MapaContenido } from "@/lib/contenido-tours";

let pendiente: Promise<MapaContenido | null> | null = null;
const pedir = () => (pendiente ??= fetch("/api/sitio/tours").then((r) => (r.ok ? r.json() : null)).catch(() => null));

export function useContenidoTours(): MapaContenido | null {
  const [mapa, setMapa] = useState<MapaContenido | null>(null);
  useEffect(() => { if (process.env.NEXT_PUBLIC_EXPORT === "1") return; let vivo = true; void pedir().then((m) => { if (vivo) setMapa(m); }); return () => { vivo = false; }; }, []);
  return mapa;
}
